import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class Loader implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
